import {Repository} from '@s-ui/domain'

/**
 * @implements Repository
 */
export default class SessionStorageRepository extends Repository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   */
  constructor({config}) {
    super({config})

    this._config = config
    this._storage = window.sessionStorage

    this._sessionKeyPrefix = this._config.get('tracking').SESSION_TRACKING_IDENTIFIED_USER_KEY_PREFIX
  }

  /**
   * @method
   * @private
   */
  _sessionKey = ({userId}) => `${this._sessionKeyPrefix}${userId}`

  /**
   * @method
   * @public
   */
  async identifyUser({userId}) {
    const key = this._sessionKey({userId})

    this._storage.setItem(key, true)

    return true
  }

  /**
   * @method
   * @public
   */
  async checkIfUserIsIdentified({userId}) {
    const key = this._sessionKey({userId})

    return Boolean(this._storage.getItem(key))
  }

  /**
   * @method
   * @public
   */
  async getExpiredSession() {
    let n = this._storage.length

    while (n--) {
      const key = this._storage.key(n)

      if (key.includes(this._sessionKeyPrefix)) return key
    }
  }

  /**
   * @method
   * @public
   */
  async removeSession({session}) {
    this._storage.removeItem(session)

    return true
  }
}
